import { useState } from "react"
import { contactSchema } from "@/lib/validations/contact"
import type { ContactFormData } from "@/lib/validations/contact"

export function useContactForm() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (formData: ContactFormData) => {
    try {
      setIsLoading(true)
      setError(null)
      
      // Validate form data and use it
      const validatedData = contactSchema.parse(formData)
      console.log('Sending data:', validatedData)
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      setSuccess(true)
    } catch (err) {
      setError("Something went wrong. Please try again.")
    } finally {
      setIsLoading(false)
    }
  }

  return { handleSubmit, isLoading, error, success }
} 